import { render, staticRenderFns } from "./Branch.version.1.vue?vue&type=template&id=01a7c0d4&"
import script from "./Branch.version.1.vue?vue&type=script&lang=js&"
export * from "./Branch.version.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports